module.exports = __webpack_public_path__ + "static/35-d666f97ca467b4071eca217da891fe48.jpg";